<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div :class="[$style.createAccount,
                {[$style.createAccountMobile]: isMobilePlatform }]">
    <template v-if="!isMobilePlatform">
      <Logo :class="$style.logoLink" />
      <div v-if="user"
           :class="$style.accountTitle">
        <h3>My Account</h3>
      </div>
      <div v-else
           :class="$style.accountTitle">
        <h4>A new account!</h4>
        <h4>Enter in the required fields below:</h4>
      </div>
    </template>

    <form :class="$style.accountForm"
          @submit.prevent="onSubmit">
      <v-layout row>
        <v-flex xs12
                md10
                lg6
                offset-xs0
                offset-md1
                offset-lg3>
          <v-layout row
                    wrap
                    justify-space-between>
            <v-flex :class="$style.appGrid"
                    xs12
                    md6>
              <InputField :class="[$style.accountFormField,
                                   {[$style.errorField] :
                          $v.firstName.$error }]"
                          v-model="$v.firstName.$model"
                          label="First Name*"
                          type="text"/>
              <p v-if="$v.firstName.$error"
                 :class="$style.errorMessage">
                First Name is required
              </p>
            </v-flex>
            <v-flex :class="$style.appGrid"
                    xs12
                    md6 >
              <InputField :class="[$style.accountFormField,
                                   {[$style.errorField] : $v.lastName.$error }]"
                          v-model="$v.lastName.$model"
                          label="Last Name*"
                          type="text"/>
              <p v-if="$v.lastName.$error"
                 :class="$style.errorMessage">
                Last Name is required
              </p>
            </v-flex>
            <v-flex :class="$style.appGrid"
                    xs12
                    md6 >
              <InputField :class="[$style.accountFormField,
                                   {[$style.errorField] : $v.email.$error }]"
                          v-model="$v.email.$model"
                          label="Email*"
                          type="email"/>
              <p v-if="$v.email.$error"
                 :class="$style.errorMessage">
                Email is required
              </p>
            </v-flex>
            <v-flex :class="$style.appGrid"
                    xs12
                    md6 >
              <InputField :class="[$style.accountFormField,
                                   {[$style.errorField] : $v.phone.$error }]"
                          :return-masked-value="false"
                          v-model="$v.phone.$model"
                          mask="+1 (###) ### - ####"
                          placeholder="+1 (xxx) xxx - xxxx"
                          label="Phone Number*"
                          type="tel"/>
              <p v-if="$v.phone.$error"
                 :class="$style.errorMessage">
                Phone is required
              </p>
            </v-flex>
            <v-flex :class="$style.appGrid"
                    md6 >
              <DatePicker v-model="birthday"
                          label="Birthday (optional)" />
            </v-flex>
            <v-flex :class="$style.appGrid"
                    xs12
                    md6 >
              <InputField v-if="user"
                          :class="[$style.accountFormField]"
                          v-model="updatedPassword"
                          :type="show ? 'text' : 'password'"
                          :placeholder="passwordPlaceholder"
                          label="Password"/>
              <InputField v-else
                          :class="[$style.accountFormField,
                                   {[$style.errorField] :
                          $v.newPassword.$error }]"
                          v-model="$v.newPassword.$model"
                          :type="show ? 'text' : 'password'"
                          label="Password*"/>
              <p v-if="$v.newPassword.$error"
                 :class="$style.errorMessage">
                Wrong password
              </p>

              <button v-if="!user || updatedPassword"
                      :class="$style.passVisibility"
                      @click.prevent="show = !show">
                {{ showPassMessage() }}
              </button>
            </v-flex>
            <v-flex :class="$style.appGrid"
                    xs12
                    md6 >
              <InputField :class="$style.accountFormField"
                          v-model="address"
                          label="Mailing Address (optional)"
                          type="text"/>

              <div :class="$style.addressGroup">
                <InputField :class="$style.accountFormField"
                            v-model="city"
                            placeholder="City"
                            type="text"/>
                <SelectField :class="$style.addressGroupSelect"
                             v-model="state"
                             :items="states"
                             placeholder="State"/>
                <InputField :class="$style.accountFormField"
                            v-model="zip"
                            placeholder="Zip"
                            type="text"/>
              </div>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>

      <v-layout v-if="false"
                row>
        <v-flex offset-md1
                offset-lg3
                md10
                lg6>
          <h6 :class="$style.preferencesTitle">Preferences (optional)</h6>
          <v-layout row
                    wrap
                    justify-space-between>
            <v-flex :class="$style.appGrid"
                    xs12
                    md6>
              <SelectField :class="$style.preferenceSelect"
                           :items="states"
                           label="Preference Question #1"/>
            </v-flex>
            <v-flex :class="$style.appGrid"
                    xs12
                    md6>
              <SelectField :class="$style.preferenceSelect"
                           :items="states"
                           label="Preference Question #2"/>
            </v-flex>
            <v-flex :class="$style.appGrid"
                    xs12
                    md6>
              <SelectField :class="$style.preferenceSelect"
                           :items="states"
                           label="Preference Question #3"/>
            </v-flex>
            <v-flex :class="$style.appGrid"
                    xs12
                    md6>
              <SelectField :class="$style.preferenceSelect"
                           :items="states"
                           label="Preference Question #4"/>
            </v-flex>
          </v-layout>

        </v-flex>

      </v-layout>

      <v-layout v-if="!isMobilePlatform"
                row>
        <v-flex>
          <BaseButton v-if="!user"
                      :disabled="isLoading"
                      :class="$style.accountSubmit"
                      button-style="Main"
                      type="submit">
            Submit
          </BaseButton>
          <BaseButton v-else
                      :disabled="isLoading"
                      :class="$style.accountSubmit"
                      button-style="Main"
                      type="submit">
            Save
          </BaseButton>
        </v-flex>
      </v-layout>

      <v-layout v-if="!isMobilePlatform">
        <v-flex>
          <button :class="$style.accountCancel"
                  @click="cancelAccountCreation">Cancel</button>
        </v-flex>
      </v-layout>
    </form>
  </div>
</template>

<script>
import Component from 'vue-class-component';
import Vue from 'vue';
import { required, email, requiredIf } from 'vuelidate/lib/validators';
import { Watch, Emit } from 'vue-property-decorator';
import Logo from '@/components/Logo';
import { Getter, Action } from 'vuex-class';
import BaseButton from '@/components/BaseButton';
import InputField from '@/components/InputField';
import SelectField from '@/components/SelectField';
import LoadingMixin from '@/lib/mixins/loading-mixin';
import DatePicker from '@/components/DatePicker';
import { CART_CALC_ORDER } from '@/apps/cart/store/types';

/**
 * Page to display and edit users account data.
 */
@Component({
  name:       'CreateAccount',
  components: {
    DatePicker,
    BaseButton,
    Logo,
    InputField,
    SelectField,
  },
  validations: {
    firstName:   { required },
    lastName:    { required },
    phone:       { required },
    email:       { required, email },
    newPassword: { required: requiredIf('isPasswordRequired') },
  },
  props: {
    /* Update profile from outside trigger */
    update: {
      type:     Boolean,
      default:  false,
      required: false,
    },
    /* Create profile from outside trigger */
    create: {
      type:     Boolean,
      default:  false,
      required: false,
    },
    checkoutAfterLogin: {
      type:    Boolean,
      default: false,
    },
  },
  mixins: [
    LoadingMixin,
  ],
})
export default class DesktopCreateAccount extends Vue {
  // Users phone from store
  @Getter('authPhone') authPhone;
  @Getter('authUser') user;
  @Getter('password') userPassword;
  @Getter('authModalSignIn') modalSignIn;
  @Getter isMobilePlatform;

  @Getter('guestAccountData') guestAccountData;
  @Getter cartIsEmpty;
  @Action(CART_CALC_ORDER) cartCalcOrder;
  @Action('AUTH_CUSTOMER_TOKEN') setCustomerToken;
  @Action('SEND_ACCOUNT_DATA') sendUser;
  @Action('AUTH_MODAL') showModal;

  get isPasswordRequired() {
    return !this.user;
  }

  get passwordPlaceholder() {
    return '\u2022'.repeat(10);
  }

  /**
   * Watch for update profile from outside.
   * @param {Boolean} value.
   */
  @Watch('update')
  updateUserProfile(value) {
    if (value) {
      this.updateAccount();
    }
  }

  /**
   * Watch for create profile from outside.
   * @param {Boolean} value.
   */
  @Watch('create')
  createUserProfile(value) {
    if (value) {
      this.createAccount();
    }
  }

  /**
   * Emit event on update profile complete.
   * @param {Boolean} success - update success status.
   */
  @Emit()
  updateComplete(success) {
    return success;
  }

  /**
   * Emit event on create profile complete.
   * @param {Boolean} success - create success status.
   * @param userData
   */
  @Emit()
  createComplete(success, userData = null) {
    return [ success, userData ];
  }

  mounted() {
    if (this.user) {
      this.firstName = this.user.firstName;
      this.lastName = this.user.lastName;
      this.phone = this.user.phone;
      this.email = this.user.email;
      this.birthday = this.user.birthday;
      this.city = this.user.city;
      this.zip = this.user.zip;
      this.state = this.user.state;
    } else  if (this.guestAccountData) {
      this.firstName = this.guestAccountData.firstName;
      this.lastName = this.guestAccountData.lastName;
      this.email = this.guestAccountData.email;
    }

    if (!this.user && !this.authPhone) {
      if (this.isMobilePlatform) {
        this.$router.push({ name: 'join-sign-in' });
      } else {
        this.$router.push({ name: 'main' });
        this.showModal({ name: 'signIn', value: true });
      }
    }

    if (!this.user || this.authPhone) {
      this.phone = this.authPhone;
    }
  }

  show = false;
  firstName = '';
  lastName = '';
  email = '';
  phone = '';
  newPassword = '';
  updatedPassword = '';
  birthday = '';
  city = '';
  address = '';
  zip = '';
  state = '';
  states = [
    'CA',
    'MI',
    'LA',
    'AR',
  ];

  onSubmit() {
    if (!this.user) {
      this.createAccount();
    } else {
      this.updateAccount();
    }
  }

  updateAccount() {
    this.$v.$touch();
    if (this.$v.$invalid) {
      this.updateComplete(false);

      return;
    }

    this.loadingStart();

    const dataToSend = {
      phone:    (this.phone.startsWith('+')) ? this.phone : `+${this.phone}`,
      password: this.updatedPassword,
    };

    Object.keys(this.user).forEach((fieldName) => {
      if (this.user[fieldName] !== this[fieldName] && fieldName !== 'phone') {
        dataToSend[fieldName] = this[fieldName];
      }
    });

    this.sendUser({
      user:    dataToSend,
      updated: true,
    })
      .then(
        () => {
          if (this.update) {
            this.updateComplete(true);
          } else {
            this.$router.push({ name: 'account' });
          }
        },
        /* response error handler */
        () => {
          console.error('Problems with updating account info');
          this.updateComplete(false);
        }
      )
      .finally(this.loadingStop);
  }

  createAccount() {
    this.$v.$touch();
    if (this.$v.$invalid) {
      this.createComplete(false);

      return;
    }

    this.loadingStart();

    const dataToSend = {
      firstName: this.firstName,
      lastName:  this.lastName,
      email:     this.email,
      birthday:  this.birthday,
      city:      this.city,
      zip:       this.zip,
      state:     this.state,
      password:  this.newPassword,
      phone:     (this.phone.startsWith('+')) ? this.phone : `+${this.phone}`,
    };

    this.sendUser({
      user:    dataToSend,
      updated: false,
    })
      .then(
        () => {
          const resp = this.setCustomerToken({
            password: dataToSend.password,
            phone:    dataToSend.phone,
          });

          resp
            .then(async (userData) => {
              if (!this.cartIsEmpty) {
                try {
                  await this.cartCalcOrder();
                } catch (error) {
                  console.error(error);
                }
              }

              if (this.create) {
                this.createComplete(true, userData);
              } else {
                this.$router.push({ path: this.$route.params.goAfterCreation });
              }
            });
        },
        /* response error handler */
        () => {
          console.error('Problems with creating account info');
          this.createComplete(false);
        }
      )
      .finally(this.loadingStop);
  }

  showPassMessage() {
    if (this.show) {
      return 'Hide';
    }

    return 'Show';
  }

  /* Redirect to Menu on Cancel */
  cancelAccountCreation() {
    this.$router.push({ name: 'menu' });
  }
}
</script>

<style lang="scss" module>
@import "~@/style/variables.scss";
@import "~@/style/helpers.scss";

.createAccount {
  background-color: $white;
}

.createAccount .appGrid {
  position: relative;
  width: calc(50% - 33px);
  flex-basis: auto;
  max-width: none;
  @extend %flex;
}

.logoLink {
  display: block;
  text-align: center;
  padding-top: 22px;
  margin: 0 auto 19px;
  max-width: 169px;
}

.accountTitle h4 {
  font-family: 'Gotham', sans-serif;
  font-size: 14px;
  line-height: 22px;
  text-align: center;
  font-weight: 300;
  color: $black;
}

.accountTitle h3 {
  font-family: 'Dekers', sans-serif;
  font-size: 17px;
  line-height: 20px;
  text-align: center;
  font-weight: 500;
  color: $black;
}

.accountForm {
  margin-top: 20px;
  padding-bottom: 36px;
}

.accountFormField {
  margin: 0 0 15px;
}

.accountForm .accountFormField.errorField label {
    color: red;
}

.createAccount .accountForm {
  .accountFormField.errorField > div > div > div::before {
      border-color: $red-color;
  }
}

.errorMessage {
  text-align: left;
  font-size: 12px;
  font-style: italic;
  color: $red-color;
  margin-top: -30px;
  margin-bottom: 14px;
}


.passVisibility {
  position: absolute;
  color: $links-color;
  right: 20px;
  top: 16px;
  outline: none;
}

.addressGroup {
  display: flex;
  margin-top: -30px;
}

.addressGroup .accountFormField:last-child {
  width: 96px;
}

.addressGroup .addressGroupSelect {
  width: 55px;
  margin: 0 12px;
}

.preferencesTitle {
  text-align: center;
  margin-top: 5px;
}

.preferenceSelect {
  margin-bottom: 20px;
}

.accountSubmit {
  margin: 0 auto 26px;
  padding: 26px 140px;
  height: auto;
}

.accountCancel {
  display: block;
  margin: 0 auto;
  color: $links-color;
  font-family: 'Gotham', sans-serif;
  font-size: 14px;
  font-weight: 300;
  outline: none;
}

.createAccount .accountForm label {
  font-family: 'Gotham', sans-serif;
  font-weight: 700;
  font-size: 16px;
  color: $label-green;
}

@media screen and (max-width: 959px) {
  .createAccount .appGrid {
    width: 100%;
  }
  .passVisibility {
    right: 30px;
  }
}

@media screen and (max-width: 767px) {
  .createAccount {
    background-color: $light-cart-bg;
  }

  .preferencesTitle {
    text-align: left;
    color: $title-black;
    padding: 0 15px;
    text-transform: uppercase;
    opacity: 0.3;
    font-size: 14px;
    margin-bottom: 18px;
  }
}

@media screen and (max-width: 480px) {
  .accountSubmit {
    padding: 16px 46px;
    div {
      font-size: 14px;
      line-height: 14px;
    }
  }
}

.createAccountMobile {
  .accountForm {
    margin: 0;
    padding: 30px 0 20px 0;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/CreateAccount.vue